<template>
  <Modal
    v-model="visible"
    title="内勤账号"
    width="1200"
    class="my-modal top"
    :mask-closable="false"
    :footer-hide="true"
  >
    <div class="form">
      <div class="input-item">
        <span class="label">所属机构</span>
        <selectTree
            type="4"
            :multiple="false"
            v-model="searchObj.organizationId"
            ref="selectTreeRef"
            style="width:255px;"
        ></selectTree>
      </div>

      <div class="input-item">
        <span class="label">登录账号</span>
        <Input
          style="width:250px;"
          class="value"
          v-model="searchObj.account"
          placeholder="请输入"
          clearable
        />
      </div>

      <div class="input-item">
        <span class="label">账号状态</span>
        <RadioGroup v-model="searchObj.enable">
          <Radio label="">全部</Radio>
          <Radio label="1">启用</Radio>
          <Radio label="0">禁用</Radio>
        </RadioGroup>
      </div>

      <Button type="primary" @click="queryProductList">查询</Button>
    </div>

    <div class="table-box setTable">
      <loading :isShow="$root.$children[0].isShowLoading" />
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row }" slot="enable">
          <Tag color="primary" v-if="row.enable==1">启用</Tag>
          <Tag color="error" v-else>禁用</Tag>
        </template>
      </Table>
    </div>

    <div class="pageBox">
      <Page
        :total="total"
        :current="searchObj.pageNo"
        :page-size="searchObj.pageSize"
        show-total
        @on-change="pageChange"
        style="text-align: center"
      />
    </div>
  </Modal>
</template>

<script>
import selectTree from '@/components/system/selectTree3';

export default {
  props: [],
  components: {
    selectTree
  },
  data() {
    return {
      visible: false,
      tableData: [],
      columns: [
        {
          title: "序号",
          width: 80,
          align: "center",
          type: "index",
        },
        {
          title: "所属机构",
          minWidth: 180,
          align: "center",
          key:'organizationName'
        },
        {
          title: "登录账号",
          minWidth: 180,
          align: "center",
          key:'account'
        },
        {
          title: "登录状态",
          minWidth: 180,
          align: "center",
          slot:'enable'
        }
      ],
      total: 0,
      searchObj: {
        pageNo: 1,
        pageSize: 10
      },
    };
  },
  methods: {
    open(data) {
      this.formData = JSON.parse(JSON.stringify(data));
      this.searchObj.pageNo = 1;
      this.initList();
      this.visible = true;
    },

    // 获取列表
    initList() {
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/rolesExt/pageRoleUsers",
        type: "POST",
        data: {
          ...this.searchObj,
          roleId:this.formData.id,
          
        },
      }).then((res) => {
        this.total = res.total;
        this.tableData = res.data;
        this.$root.$children[0].isShowLoading = false;
      });
    },

    // 选中产品
    confirmSelect(item) {
      this.$emit('confirm-select', item)
      this.visible = false;
    },

    // 查询
    queryProductList() {
      this.searchObj.pageNo = 1;
      this.initList();
    },

    // 分页
    pageChange(pageNo) {
      this.searchObj.pageNo = pageNo;
      this.initList();
    },
  },
};
</script>

<style lang="scss" scoped>
.my-modal {
  /deep/ {
    .ivu-modal-body {
      padding-top: 0;
      padding-bottom: 30px;
    }
  }
  .form {
    display: flex;
    align-items: center;
    margin-top: 10px;
    .input-item {
      display: flex;
      align-items: center;
      padding-right: 50px;
    }
    .label {
      min-width: 70px;
    }
    .value {
      width: 300px;
      min-width: 200px;
    }
    /deep/ .add-btn {
      background: #f59045 !important;
      border: none;
    }
  }
  .setTable {
    margin-top: 20px;
    .action {
      font-size: 12px;
    }
  }
  .pageBox {
    margin-top: 20px;
  }
  /deep/ .setTable .ivu-table th .ivu-table-cell {
    font-size: 12px;
    font-weight: bold;
    color: #272933;
  }
  /deep/ .ivu-table-tip {
    font-size: 12px;
  }
}
</style>